














import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class KeyValue extends Vue {
  
  @Prop({ default: '',  type: String}) label!: string;
  @Prop({ default: '',  type: [String, Number]}) value!: string;
  @Prop({ default: 'N/A',  type: String}) defaultVal!: string;
  @Prop({ default: 'right', type: String}) labelAlign!: 'right'|'left';
  @Prop({ default: 'default',  type: String}) spaceSplit!: 'default'|'smallLabel'|'smallValue';

  get labelClass():object {
    return  {
      label:true, 
      'label-small-label': this.spaceSplit === 'smallLabel',
      'label-default': this.spaceSplit === 'default',
      'label-small-value': this.spaceSplit === 'smallValue',
      'label-align-left': this.labelAlign === 'left',
    }
  }

  get valueClass():object {
    return  {
      'value-container':true, 
      'value-container-small-label': this.spaceSplit === 'smallLabel',
      'value-container-default': this.spaceSplit === 'default',
      'value-container-small-value': this.spaceSplit === 'smallValue',
    }
  }
}
